import { useAuth } from '@/hooks/useAuth';

export function useIsClient(): boolean {
  const { user } = useAuth();
  return user?.role === 'client_admin' || user?.role === 'client_user';
}
